// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"oS","cross":"oT","iconSVGWrapper":"oU","iconSVG":"oV","iconSVGDark":"oW"};